/** 현재 월을 API 기준년월(yyyyMM) 형식으로 반환 */
export const getDefaultRefYm = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${now.getFullYear()}${month}`;
};

/**
 * 레거시 `getPreviousMonths` — `['YYYY-MM', ...]` 최근 n개월 (현재 월부터).
 * Select 옵션 라벨용이며, 값으로 쓰려면 `-`를 제거한다.
 *
 * 연·월을 정수로 계산한다. `Date.setMonth`는 31일에서 이전달로 가면
 * (예: 8/31 → 7/31 → 6/31 없음 → 7/1) 같은 월이 두 번 나와 Select 키가 충돌한다.
 */
export const getPreviousMonths = (numMonths: number): string[] => {
  const months: string[] = [];
  const now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  for (let i = 0; i < numMonths; i += 1) {
    months.push(`${year}-${String(month).padStart(2, '0')}`);
    month -= 1;
    if (month === 0) {
      month = 12;
      year -= 1;
    }
  }
  return months;
};

export const REIMBURSEMENT_OPTIONS = [
  { value: '', label: '전체' },
  { value: '급여', label: '급여' },
  { value: '급여정지', label: '급여정지' },
  { value: '보훈급여', label: '보훈급여' },
  { value: '산정불가', label: '산정불가' },
  { value: '임의불가', label: '임의불가' },
  { value: '비급여', label: '비급여' },
  { value: '삭제', label: '삭제' },
] as const;

export const formatPrice = (value: number | null | undefined): string => {
  if (value == null) return '-';
  return `${value.toLocaleString('ko-KR')}원`;
};
